import { Box, Stack } from '@mui/material';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import useEditPromocode from '../../../../../hooks/site/bonus/useEditPromocode';
import ErrorBoundary from '../../../../../components/material-ui/error_boundary/ErrorBoundary';
import PromoCreateNew from './PromoCreateNew';
import PromocodesList from './PromocodesList';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import { useState } from 'react';
import { API_GROUP } from '../../../../../api/user';

export default function Promocode({ group, groupId, groupByPromo, setGroupByPromo }) {
  const [promoDisabled, setPromoDisabled] = useState(false);
  const {
    defaultCurrency,
    listPromocodes,
    defaultNewPromo,
    chosenList,
    seriesOptions,
    promoUpdateTicker,
    status,
    setStatus,
    setPromoUpdateTicker,
    setChosenList,
    onCreate,
    onCopyClipboard,
    onDeactivate,
    onDelete
  } = useEditPromocode(groupId);

  const onGroupByPromoChange = (e) => {
    setPromoDisabled(true);
    const value = !groupByPromo;
    console.log(e.target.value);
    API_GROUP.linkPromo
      .set(groupId, value)
      .then((e) => {
        setGroupByPromo(value);
      })
      .catch(console.log)
      .finally(() => {
        setPromoDisabled(false);
      });
  };

  return (
    <Stack display={'flex'} flexDirection={'column'} gap={1} py={1}>
      <Stack display={'flex'} flexDirection={'column'} gap={1}>
        <ShowContainer condition={group.game && groupByPromo !== undefined}>
          <CusCheckbox
            checked={groupByPromo}
            label="Move the player to this game group after using the promo code"
            onChange={onGroupByPromoChange}
            disabled={promoDisabled}
          />
        </ShowContainer>
      </Stack>

      <ErrorBoundary>
        <PromoCreateNew
          group={group}
          defaultCurrency={defaultCurrency}
          defaultNewPromo={defaultNewPromo}
          onCreate={onCreate}
        />
      </ErrorBoundary>

      <ErrorBoundary>
        <PromocodesList
          groupId={groupId}
          listPromocodes={listPromocodes}
          chosenList={chosenList}
          seriesOptions={seriesOptions}
          status={status}
          promoUpdateTicker={promoUpdateTicker}
          setStatus={setStatus}
          setChosenList={setChosenList}
          onCopyClipboard={onCopyClipboard}
          onDeactivate={onDeactivate}
          onDelete={onDelete}
          setPromoUpdateTicker={setPromoUpdateTicker}
        />
      </ErrorBoundary>
    </Stack>
  );
}
